import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

// antd
import { Affix } from 'antd';

// styling
import './index.less';

/**
 * @param {number} [affixOffsetTop=-32] Sticky offset from viewport top.
 * Default -32 preserves historical layout (Job Description tabs, etc.).
 * @param {string} [contentClassName] Extra class on the content panel, for page-specific styling.
 * @param {boolean} [pinnedDivider=true] Draw a divider under the header while it is pinned, so it stays
 * distinct from the content scrolling beneath it. Work Status draws its own, so it turns this off.
 * Work Status detail uses 60 so Update/Print sit below the fixed layout header.
 */
const PageHeaderContainer = ({
  header,
  children,
  showHeader = false,
  custom = false,
  pdemo = false,
  pinnedDivider = true,
  contentClassName = '',
  affixOffsetTop = -32,
}) => {
  const location = useLocation();
  const [pinned, setPinned] = useState(false);

  // Headers pinned partly under the fixed nav (negative offset) get breathing room under its bottom line.
  // Work Status pins below the nav (positive offset) and handles its own spacing.
  const headerClassName =
    [affixOffsetTop < 0 ? 'page-header-container-header-spaced' : '', pinned && pinnedDivider ? 'page-header-container-header-pinned' : ''].filter(Boolean).join(' ') || undefined;

  let style = '';

  if (pdemo) {
    style = 'page-header-container-pdemo-content';
  } else if (custom) {
    style = 'page-header-container-custom-content';
  } else {
    style = 'page-header-container-content';
  }

  return (
    <div className="page-header-container">
      {(location.search !== '' || showHeader) && (
        <Affix offsetTop={affixOffsetTop} onChange={setPinned}>
          <div className={headerClassName}>{header}</div>
        </Affix>
      )}
      <div className={contentClassName ? `${style} ${contentClassName}` : style}>{children}</div>
    </div>
  );
};

export default PageHeaderContainer;
